/**
 * @generated SignedSource<<5b429f4036d9df1bba34723b0914b70c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CutOffTableHeader_header$data = {
  readonly tableHeader: ReadonlyArray<{
    readonly col: string | null | undefined;
    readonly label: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "CutOffTableHeader_header";
};
export type CutOffTableHeader_header$key = {
  readonly " $data"?: CutOffTableHeader_header$data;
  readonly " $fragmentSpreads": FragmentRefs<"CutOffTableHeader_header">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CutOffTableHeader_header",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TableHeader",
      "kind": "LinkedField",
      "name": "tableHeader",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "col",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CutOffTable",
  "abstractKey": null
};

(node as any).hash = "52a92ca00c3807401e49d49c05ee8ed6";

export default node;
